import {useState} from "react"

export function Switcher({checked: checkedDefault = false, disabled = false, onChange}) {
  const [checked, setChecked] = useState(checkedDefault)

  const handleChange = () => {
    setChecked(!checked)
    onChange?.(!checked)
  }

  return (
    <label className="switcher">
      <input type="checkbox" checked={checked} onChange={handleChange} disabled={disabled}/>
      <span className="slider-switch" style={disabled ? {opacity: .5, cursor: 'default'} : {}}/>
    </label>
  )
}